import { createSlice } from "@reduxjs/toolkit";
import { aplicarMascaraTelefone, aplicarMascaraCEP } from "../../../../lib/formatarCampos";
const initialImportacaoArquivoState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  agenteForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const importacaoArquivoSlice = createSlice({
  name: "importacaoArquivo",
  initialState: initialImportacaoArquivoState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    // getAgenteById
    agenteFetched: (state, action) => {


      state.listLoading = false;
      // APLICAR A MASCARA
      state.agenteForEdit = action.payload.agenteForEdit;
      state.error = null;

    },
    // findImportacaoArquivo
    agentesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createAgente
    agenteCreated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities.push(action.payload.agente);
    },
    // updateAgente
    agenteUpdated: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.agente.id) {
          return action.payload.agente;
        }
        return entity;
      });
    },
    // deleteAgente
    agenteDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteImportacaoArquivo
    agentesDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // agentesUpdateState
    agentesStatusUpdated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
